import {
  DefenseArmStatusTypes,
  DefenseEventTypes,
  IDefenseEventNotifySyncDeviceProps,
} from '../../../../services/Defense/Events/types';
import TableComponent, {
  IColumnProps,
} from '../../../../components/TableComponent';
import { Grid2 } from '@mui/material';
import TextFieldComponent from '../../../../components/TextFieldComponent';
import {
  convertArmStatus,
  convertEventType,
} from '../../../../converters/Defense/ConverterDefense';
import React from 'react';

interface IDefenseNotifySyncDeviceContentProps {
  event: IDefenseEventNotifySyncDeviceProps;
}

const DefenseNotifySyncDeviceContent = ({
  event,
}: IDefenseNotifySyncDeviceContentProps) => {
  const columnsAreas: IColumnProps[] = [
    {
      id: 'id',
      label: 'ID',
      width: 'auto',
    },
    {
      id: 'areaId',
      label: 'ID de Área',
      width: 'auto',
    },
    {
      id: 'areaName',
      label: 'Nome da Área',
      width: 'auto',
    },
    {
      id: 'armStatus',
      label: 'Status',
      width: 'auto',
      render: (armStatus: string) => {
        return <>{convertArmStatus(armStatus as DefenseArmStatusTypes)}</>;
      },
    },
  ];

  const columnsPartitions: IColumnProps[] = [
    {
      id: 'id',
      label: 'ID',
      width: 'auto',
    },
    {
      id: 'partitionId',
      label: 'ID de Partição',
      width: 'auto',
    },
    {
      id: 'partitionName',
      label: 'Nome da Partição',
      width: 'auto',
    },
  ];

  const getFormatedDate = (date: Date) => {
    return new Date(date.toLocaleString('pt-BR'));
  };

  return (
    <Grid2
      container
      direction="column"
      spacing={2}
      justifyContent={'center'}
      alignItems={'center'}
      size={12}
    >
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <TextFieldComponent
          label="Dispositivo"
          value={event?.device?.name ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Tipo"
          value={
            convertEventType(event.type as DefenseEventTypes) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 6 }} mb={3}>
        <TextFieldComponent
          label="Data/Hora"
          value={getFormatedDate(event.createdAt) ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Descrição"
          value={event.description ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          multiline
        />
      </Grid2>
      {event.areas.map((area, idx) => (
        <Grid2
          key={idx}
          flexDirection={{ xs: 'column', lg: 'row' }}
          justifyContent={{ xs: 'center', lg: 'space-between' }}
          alignItems={'center'}
          size={12}
        >
          <TableComponent key={idx} rows={[area]} columns={columnsAreas} />
          <TableComponent
            key={idx}
            rows={area.partitions}
            columns={columnsPartitions}
          />
        </Grid2>
      ))}
    </Grid2>
  );
};

export default DefenseNotifySyncDeviceContent;
